export const toggleSidebar = () => {
  const sidebar = document.getElementById("sidebar");
  const aside = document.getElementById("mainAside");
  const overlay = document.getElementById("sidebarOverlay");

  if (!sidebar || !aside) return;

  if (window.innerWidth >= 992) {
    sidebar.classList.toggle("desktop-hidden");
    aside.classList.toggle("desktop-full");
  } else {
    sidebar.classList.toggle("active");

    if (overlay) {
      overlay.classList.toggle("active");
    }
  }
};

// const toggleSidebar = () => {
//   const sidebar = document.getElementById("sidebar");
//   const aside = document.getElementById("mainAside");

//   if (window.innerWidth >= 992) {
//     sidebar.classList.toggle("desktop-hidden");
//     aside.classList.toggle("desktop-full");
//   } else {
//     sidebar.classList.toggle("active");
//     document.getElementById("sidebarOverlay").classList.toggle("active");
//   }
// };
